export default __webpack_public_path__ + "static/media/Armbands of the Stormbringer.b56ca9ec.jpg";